import React from 'react';

import webchatIcon from '../../../assets/images/webchat_icon.svg';
import messengerIcon from '../../../assets/images/messenger_icon.svg';
import whatsappIcon from '../../../assets/images/whatsapp_icon.svg';
import instagramIcon from '../../../assets/images/instagram_icon.svg';

const channelsIcon = (channel) => {
  const channels = {
    webchat: webchatIcon,
    messenger: messengerIcon,
    whatsapp: whatsappIcon,
    instagram: instagramIcon,
  };
  return channels[channel];
};
const HistoryDescription = ({ history }) => {
  if (history?.newPlan?.amountWhatsappConversation !== undefined) {
    if (history?.newPlan?.name === 'Freemium') {
      return (
        <div className="container-img-channels-history">
          <img src={webchatIcon} alt="webchat icon" />
          <p>1000/mês</p>
        </div>
      );
    }
    return (
      <div className="container-img-channels-history">
        <img src={whatsappIcon} alt="whatsapp icon" />
        <p>{history.newPlan?.amountWhatsappConversation || 0}/mês</p>
      </div>
    );
  }

  if (
    history?.newPlan?.amountWhatsappConversation === undefined &&
    history?.newPlan?.franchise?.length > 0
  ) {
    return history.newPlan?.franchise.map((pack) => (
      <div className="container-img-channels-history" key={pack?._id}>
        {pack?.channels?.map((channel) => (
          <img src={channelsIcon(channel)} alt={channel} key={channel} />
        ))}
        <p>{pack.amountMessage}/mês</p>
      </div>
    ));
  }

  if (history?.addtionalMessage) {
    return (
      <div className="container-img-channels-history">
        {history.addtionalMessage?.channels?.map((channel) => (
          <img src={channelsIcon(channel)} alt={channel} key={channel} />
        ))}
        <p>{history.addtionalMessage?.value} adicional</p>
      </div>
    );
  }

  if (!history.newPlan?.franchise?.length > 0 && !history.addtionalMessage) {
    return '-';
  }
};

export default HistoryDescription;
